module.exports = __webpack_public_path__ + "img/43exp.69e8d46c.jpg";